// extracted by mini-css-extract-plugin
var _1 = "MobileElement_active__da2ba";
var _2 = "MobileElement_additions__91017";
var _3 = "MobileElement_arrowIcon__cb190";
var _4 = "MobileElement_bottomLabel__f643c";
var _5 = "MobileElement_customIcon__9d98d";
var _6 = "MobileElement_empty__8d63b";
var _7 = "MobileElement_fact__42413";
var _8 = "MobileElement_icon__3bda7";
var _9 = "MobileElement_item__972fe";
var _a = "MobileElement_root__1c10f";
var _b = "MobileElement_row__4156d";
var _c = "MobileElement_topLabel__b7ef0";
export { _1 as "active", _2 as "additions", _3 as "arrowIcon", _4 as "bottomLabel", _5 as "customIcon", _6 as "empty", _7 as "fact", _8 as "icon", _9 as "item", _a as "root", _b as "row", _c as "topLabel" }
